import { Injectable } from '@angular/core';
import {ApiRouteConfig} from "../../config/api.route.config";
import {HttpClient} from "@angular/common/http";
import {SystemNotification} from "./system-notification";
import {SystemNotificationDto} from "./systemNotificationDto";
import {interval, Observable} from "rxjs";
import {map, share, shareReplay, startWith, switchMap} from "rxjs/operators";
import {AppConfig} from "../../config/app.config";
import {filterCollection} from "../../helpers/collections";

@Injectable()
export class SystemNotificationsService {
  

  constructor(
      private readonly config: AppConfig,
      private readonly api: ApiRouteConfig,
      private readonly httpClient: HttpClient,
  ) { }
  
  public active$ = interval(this.config.SYSTEM_NOTIFICATION_INTERVAL)
      .pipe(startWith(0), switchMap(() => this.active), shareReplay());
  public get active(): Observable<SystemNotification[]> {
    return this.httpClient.get<SystemNotificationDto[]>(
        this.api.ACTIVE_SYSTEM_NOTIFICATION,
    ).pipe(
        map(dtos => dtos.map(dto => SystemNotification.unmarshallFrom(dto))),
        filterCollection(notification => notification.isActive),
    );
  }
}
